import { Typography } from '@mui/material';
import { VersionContext } from 'lib/context/VersionProvider';
import React, { useContext } from 'react';

interface VersionDisplayProps {
  sx?: object;
}

export const VersionDisplay: React.FC<VersionDisplayProps> = ({ sx = {} }) => {
  const { currentVersion } = useContext(VersionContext);

  const getLastFourChars = (version: string | null): string => {
    if (!version) return 'N/A';
    return version.slice(-4);
  };

  return (
    <Typography
      color="text.secondary"
      sx={{
        fontFamily: 'monospace',
        fontSize: '0.75rem',
        textAlign: 'right',
        ...sx,
      }}
    >
      v{getLastFourChars(currentVersion)}
    </Typography>
  );
};

export default VersionDisplay;
